const DeviceModelList = () => import('Views/deviceModel/deviceModel-list');
const DeviceModelAddEdit = () => import('Views/deviceModel/deviceModel-addEdit');
const DeviceModelDetail = () => import('Views/deviceModel/deviceModel-detail');

export default[
  { path: '/deviceModel-list', component: DeviceModelList },
  { path: '/deviceModel-add', component: DeviceModelAddEdit },
  { path: '/deviceModel-edit/:id', component: DeviceModelAddEdit },
  { path: '/deviceModel-detail/:id', component: DeviceModelDetail },
];



// WEBPACK FOOTER //
// ./src/router/deviceModel.js